import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { IPropertyBag } from '@deity-io/di-data-basics';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties } from '@material-ui/styles';
import PropertyListEditor from 'components/PropertyListEditor/PropertyListEditor';
import type { FC } from 'react';
import { forwardRef } from 'react';
// import ProcessorFields from './ProcessorFields/ProcessorFields';

type ProcessorItemProps = {
  locked?: boolean;
  type: string;
  persistedValue: {};
  processorProperties: {};
  index: string;
  owner?: any;
  onRemove?: (index: string) => void;
  onValueChange: (key: Array<string>, value: string | number | boolean | undefined | {}) => void;
};
const ProcessorItem: FC<ProcessorItemProps> = ({
  locked,
  index,
  type,
  persistedValue,
  processorProperties,
  owner,
  onRemove,
  onValueChange
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: index });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || ''
  };

  return (
    <Item
      ref={setNodeRef}
      onValueChange={onValueChange}
      style={style}
      owner={owner}
      index={index}
      persistedValue={persistedValue}
      processorProperties={processorProperties}
      type={type}
      {...attributes}
      {...listeners}
      locked={locked}
      onRemove={(indexToRemove: string) => onRemove && onRemove(indexToRemove)}
    />
  );
};

type ItemProps = {
  locked?: boolean;
  index: string;
  type: string;
  persistedValue: IPropertyBag;
  processorProperties: {};
  owner: any;
  style: CSSProperties;
  onRemove?: (index: string) => void;
  onValueChange: (key: Array<string>, value: string | number | boolean | undefined | {}) => void;
};

export default ProcessorItem;

const Item = forwardRef<HTMLDivElement, ItemProps>(
  (
    { locked, index, onValueChange, type, persistedValue, processorProperties, onRemove, style, owner, ...props },
    ref
  ) => (
    <FlexLayout
      ref={ref}
      style={style}
      width="full"
      p="sm"
      bg="lightGrey"
      flexWrap="nowrap"
      borderRadius="small"
      mb="xs"
      css={{
        ':hover': {
          '#delete-processor': {
            opacity: 1
          }
        }
      }}
    >
      <FlexLayout flexDirection="column" alignItems="center" mr="xs">
        <FlexLayout
          p="xs"
          mb="sm"
          bg="white"
          alignItems="center"
          justifyContent="center"
          border="regular"
          borderColor="secondary"
          style={{ width: '32px', height: '32px', borderRadius: '50%' }}
        >
          <H4 color="secondary" fontSize="sm">
            {index}
          </H4>
        </FlexLayout>
        {!locked && (
          <Icon
            src="dragIndicator"
            color="primary"
            stroke="transparent"
            style={{ cursor: 'grab' }}
            mb="sm"
            {...props}
          />
        )}
        {!locked && onRemove && (
          <Icon
            id="delete-processor"
            src="deleteOutline"
            color="primary"
            stroke="transparent"
            opacity="none"
            style={{ cursor: 'pointer', transition: 'opacity .2s ease-in-out' }}
            onClick={() => onRemove && onRemove(index)}
          />
        )}
      </FlexLayout>
      <FlexLayout flexDirection="column" width="full">
        <FlexLayout>
          <H4>Type {persistedValue?.type}</H4>
          <PropertyListEditor
            locked={locked}
            data={persistedValue}
            propertyList={processorProperties}
            onChange={onValueChange}
            owner={owner}
          />
          {/* <ProcessorFields
              persistedValue={persistedValue}
              processorProperties={processorProperties}
              isEditable={isEditable}
              onValueChange={onValueChange}
            /> */}
        </FlexLayout>
      </FlexLayout>
    </FlexLayout>
  )
);
